import React from "react";

function Reports({ leads }) {
  const metric = (status) => leads.filter((lead) => lead.status === status).length;

  return (
    <section className="procrm-panel crm-section">
      <div className="panel-heading">
        <div>
          <span className="eyebrow">Weekly Reporting</span>
          <h2>Pipeline performance overview</h2>
        </div>
      </div>

      <div className="crm-report-grid">
        <div>
          <span>New leads found</span>
          <strong>{leads.length}</strong>
        </div>
        <div>
          <span>Businesses contacted</span>
          <strong>{metric("Contacted")}</strong>
        </div>
        <div>
          <span>Replies received</span>
          <strong>{metric("Replied")}</strong>
        </div>
        <div>
          <span>Audits requested</span>
          <strong>{metric("Audit Requested")}</strong>
        </div>
        <div>
          <span>Audits sent</span>
          <strong>{metric("Audit Sent")}</strong>
        </div>
        <div>
          <span>Meetings booked</span>
          <strong>{metric("Meeting Booked")}</strong>
        </div>
        <div>
          <span>Quotes requested</span>
          <strong>{metric("Quote Requested")}</strong>
        </div>
        <div>
          <span>Deals closed</span>
          <strong>{metric("Won")}</strong>
        </div>
      </div>
    </section>
  );
}

export default Reports;